import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTagMore = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 11,
	height: 13,
	viewBox: "0 0 11 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.26 0.724531L6.79 0.394531C6.79 0.394531 6.71 0.404531 6.68 0.434531L0.04 7.07453C0.04 7.07453 0.02 7.10453 0.01 7.12453C0.01 7.14453 0 7.16453 0 7.17453C0 7.18453 0 7.21453 0.01 7.22453C0.01 7.24453 0.03 7.25453 0.04 7.27453L5.19 12.4245C5.19 12.4245 5.25 12.4645 5.29 12.4645C5.33 12.4645 5.36 12.4545 5.39 12.4245L7.47 10.3445L4.05 6.92453L10.26 0.724531Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgTagMore);
export { ForwardRef as ReactComponent };
